const DrawIcon = () => {
  const icons = document.querySelectorAll('.js-draw-icon')

  ;[...icons].forEach(icon => {
    window.addEventListener(
      'scroll',
      function(event) {
        if (isInViewport(icon)) {
          if (!icon.classList.contains('js-draw')) {
            let myAnimation = new LazyLinePainter(icon, {
              ease: 'easeLinear',
              strokeWidth: 2,
              strokeOpacity: 1,
              strokeColor: '#222F3D',
              strokeCap: 'square'
            })
            myAnimation.paint()
            icon.classList.add('js-draw')
          }
        } else {
          icon.classList.remove('js-draw')
        }
      },
      false
    )
  })

  const isInViewport = function(elem) {
    var bounding = elem.getBoundingClientRect()
    return (
      bounding.top >= 0 &&
      bounding.left >= 0 &&
      bounding.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
      bounding.right <=
        (window.innerWidth || document.documentElement.clientWidth)
    )
  }
}

export default DrawIcon



// WEBPACK FOOTER //
// ./src/js/modules/DrawIcon.js